var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 8,
    height: 8,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 2,
    width: 8,
    height: 8,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 8,
    height: 8,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 8,
    height: 8,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreSquare);
export default __webpack_public_path__ + "static/media/More_Square.9c98558830437f82bf638f73c6de7b5c.svg";
export { ForwardRef as ReactComponent };